<template>
  <div style="margin: 1rem 1rem 0 1rem; font-size: 0.8rem">
    <table class="agenda-table" v-for="(item, index) in table" :key="index">
      <b-tr v-if="item.text" :class="['tr', table[0].bg ? '' : 'w-bg']">
        <b-td class="td left">{{ item.time }}</b-td>

        <b-td class="td">
          <div class="subtitle" v-html="item.text"></div>
        </b-td>
      </b-tr>
      <b-tr>
        <b-td style="height: 1px; background: #dedede"></b-td>
        <b-td style="height: 1px; background: #dedede"></b-td>
      </b-tr>
      <template>
        <b-tr
          v-for="(subitem, ind) in item.arr"
          :key="ind"
          :class="['tr', table[0].bg ? 'w-bg' : '']"
        >
          <b-td class="td left" valign="top">
            <div
              style="font-family: Arial, 'Microsoft YaHei'; padding: 0.3rem 0"
            >
              {{ subitem.time }}
            </div>
          </b-td>
          <b-td class="td" style="font-family: Arial, 'Microsoft YaHei'">
            <div style="display: flex; padding: 0.3rem 0">
              <div
                :class="subitem.content.title ? 'subtitle-right' : ''"
                style="flex: 8"
              >
                <div v-html="subitem.content.class"></div>
                <div
                  style="
                    font-family: Arial, 'Microsoft YaHei';
                    font-weight: 300;
                    word-spacing: 5px;
                    letter-spacing: 0.5px;
                    padding-right: 0.6rem;
                    text-align: left;
                  "
                  v-html="subitem.content.personIntro"
                ></div>
              </div>
            </div>
          </b-td>
        </b-tr>
        <b-tr v-for="(dialogItem, index) in item.dialog" :key="index" style="">
          <b-td class="td left" valign="top"></b-td>
          <b-td class="td" valign="top">
            <div class="dialog">
              <div style="flex: 8">
                <div style="flex: 8">
                  {{ dialogItem.hostTitle }}{{ dialogItem.host }}
                </div>
                <div style="flex: 8">
                  {{ dialogItem.guestTitle }}{{ dialogItem.guest.join("、") }}
                </div>
              </div>
            </div>
          </b-td>
        </b-tr>
      </template>

      <b-tr>
        <b-td style="height: 1px; background: #dedede"></b-td>
        <b-td style="height: 1px; background: #dedede"></b-td>
      </b-tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    table: {
      type: Array,
      default: [],
    },
  },
  created() {},
  watch: {
    table(val) {},
  },
  data() {
    return {
      flag: true,
      tableData: [],
      bg: true,
    };
  },
  methods: {
    changeBg(table) {
      console.log(">>>>>>>>>>>>>>>>>>>>>", this.bg);
      table[0].text ? (this.bg = false) : (this.bg = true);
      console.log(">>>>>>>>>>>>>>>>>>>>>", this.bg);
    },
  },
};
</script>
<style lang="scss" scoped>
.agenda-table {
  width: 100%;
  text-align: left;
  color: #000823;

  .tr:first-child {
    line-height: 1.8rem;
  }

  .tr {
    width: 100%;
    background: #f1f1f1;

    .td {
      .subtitle-right {
        padding-left: 0;
      }
    }

    .left {
      width: 15%;
      word-spacing: 0;
      letter-spacing: 0;
      text-align: left;
      padding-left: 1.4rem;
    }
  }

  .w-bg {
    background: #fff;
  }

  .border-b {
    border-bottom: 0.1rem solid #b2b2b2;
  }

  .border-t {
    border-top: 0.1rem solid #b2b2b2;
  }

  .subtitle {
    font-size: 0.8rem;
  }
}
.dialog {
  display: flex;
  padding: 0.3rem 0;
  line-height: 1.5rem;
}
.agenda-wrap:last-child {
  .agenda-table:last-child {
    margin-top: 4px;
  }
}

@media (max-width: 768px) {
  .agenda-table {
    .tr {
      .td {
        padding-left: 0.6rem;

        // .subtitle-right {
        //   padding-left: 0.6rem;
        // }
      }
    }
	.dialog{
		padding-left: 0.58rem;
	}
  }
}
</style>